<template>
    <app-link :to="to" @click="$emit('click')">
        <v-alert v-ripple class="app-alert-button mb-2" :color="alertColor" text dense>
            <v-row class="app-alert-button__row" align="center" no-gutters>
                <v-col v-if="alertIcon" class="shrink">
                    <v-icon class="app-alert-button__icon" :color="alertColor" :size="iconSize">{{ alertIcon }}</v-icon>
                </v-col>
                <v-col class="grow">
                    <template v-if="Array.isArray(text)">
                        <span v-for="(textLine, index) in text" :key="`text-${index}`" class="app-alert-button__text">
                            {{ textLine }}
                        </span>
                    </template>
                    <span v-else class="app-alert-button__text">{{ text }}</span>
                </v-col>
            </v-row>
        </v-alert>
    </app-link>
</template>

<script>
import alert from '@/mixins/alert';

export default {
    name: 'AppAlertButton',
    mixins: [alert],
    props: {
        icon: {
            type: String,
            default: null
        },
        iconSize: {
            type: String,
            default: 'medium'
        },
        color: {
            type: String,
            default: 'primary'
        },
        text: {
            type: [String, Array],
            default: null
        },
        to: {
            type: [String, Object],
            default: null
        }
    }
};
</script>
